import { ApiError } from '@core/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { googleMapsApiFeatureKey } from './reducer';
import { State } from './state';

const getGoogleMapsApiLoaded = (state: State): boolean =>
  state.googleMapsApiLoaded;
const getGoogleMapsApiLoading = (state: State): boolean =>
  state.googleMapsApiLoading;
const getGoogleMapsApiFailure = (state: State): ApiError | null =>
  state.googleMapsApiLoadedFailure;

export const googleMapApiState = createFeatureSelector<State>(
  googleMapsApiFeatureKey,
);

export const selectGoogleMapsApiLoaded = createSelector(
  googleMapApiState,
  getGoogleMapsApiLoaded,
);
export const selectGoogleMapsApiLoading = createSelector(
  googleMapApiState,
  getGoogleMapsApiLoading,
);
export const selectGoogleMapsApiFailure = createSelector(
  googleMapApiState,
  getGoogleMapsApiFailure,
);
